<style scoped lang="css"></style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-lg--hover mb-3" id="main">
        <Header title="Mi checador" />
        <b-row class="mb-3">
          <b-col cols="6">
            <b-button-toolbar>
              <b-button variant="default" size="sm" @click="goBack">
                <b-icon-chevron-left scale="1.3" />
              </b-button>
            </b-button-toolbar>
          </b-col>
          <b-col cols="6">
            <b-button-toolbar class="float-right">
              <b-button-group>
                <b-button variant="primary" size="sm" @click="refresh">
                  <b-icon-arrow-clockwise scale="1.3" />
                </b-button>
              </b-button-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <b-row class="my-3" v-if="isAdmin">
          <b-col cols="12">
            <div class="d-flex justify-content-center">
              <b-button-toolbar>
                <b-button variant="info" @click="downloadReport">
                  Generar reporte de la semana
                </b-button>
              </b-button-toolbar>
            </div>
          </b-col>
          <b-col cols="12" class="mt-3">
            <div
              style="
                border-style: solid;
                border-width: 1px;
                border-color: #dee2e6;
              "
            ></div>
          </b-col>
        </b-row>
        <b-row class="mt-1 mb-3">
          <b-col v-if="isAdmin" cols="12" class="mb-3">
            <b-form-select
              v-model="selectedUser"
              :disabled="loading"
              @change="refresh()"
            >
              <b-form-select-option
                v-for="user in users"
                :key="user.email"
                :value="user.email"
              >
                {{ user.email === userEmail ? "Yo - " : "" }}{{ user.email }}
              </b-form-select-option>
            </b-form-select>
          </b-col>

          <b-col>
            <div class="d-flex justify-content-center">
              <b-button-toolbar>
                <b-button
                  variant="success"
                  v-if="!isLastCheckAnIn"
                  :disabled="loading"
                  @click="handleCheckIn"
                >
                  Entrar {{ currentTimestamp | timestamp }}
                </b-button>
                <b-button
                  variant="warning"
                  v-else
                  @click="handleCheckOut"
                  :disabled="loading"
                  >Salir {{ currentTimestamp | timestamp }}</b-button
                >
              </b-button-toolbar>
            </div>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col class="d-flex justify-content-center">
            <b-calendar
              v-model="currentDate"
              :disabled="loading"
              :min="selectableFrom"
              :date-info-fn="selectedDates"
              @context="handleCalendarContext"
              locale="es-MX"
              hide-header
            ></b-calendar>
          </b-col>
        </b-row>
        <b-skeleton-table v-if="loading" :rows="5" :columns="1" />
        <div v-else class="mb-3">
          <b-list-group v-show="!loading" v-if="checks.length > 0">
            <b-list-group-item
              v-for="check in checks"
              :key="check.timestamp"
              class="flex-column align-items-start"
              @click="seeCheckDetails(check)"
            >
              <div class="d-flex justify-content-between">
                <h5 class="mb-1">
                  <b-icon-box-arrow-in-right v-if="check.in" />
                  <b-icon-box-arrow-right v-else />
                  {{ check.timestamp | timestamp }}
                </h5>
                <b-icon-chevron-right class="mt-1"></b-icon-chevron-right>
              </div>
            </b-list-group-item>
          </b-list-group>
          <b-list-group v-else>
            <b-list-group-item>
              <span>No hay entradas para las fechas seleccionadas</span>
            </b-list-group-item>
          </b-list-group>
        </div>
      </main>
    </section>
    <b-modal id="download-artifact-modal" hide-footer centered hide-header>
      <div class="text-center">
        <a :href="currentArtifactUrl" target="_blank" class="text-center">
          Descargar
          <b-icon-link45deg scale="1.5" />
        </a>
        <div>
          <small>La liga puede ser compartida y es válida por 1 día</small>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import moment from "moment";
import Header from "../Header";
import * as R from "ramda";

moment.locale("es-us");

export default {
  name: "Checker",
  components: {
    Header,
  },
  data() {
    return {
      from: "",
      to: "",
      selectTo: false,
      currentDate: "",
      loading: false,
      currentTimestamp: Date.now(),
      users: [],
      selectedUser: null,
      currentArtifactUrl: "",
    };
  },
  async created() {
    this.to = new Date();
    const from = new Date();
    from.setDate(1);
    this.from = from;

    if (R.isEmpty(this.checks) || R.isEmpty(this.users)) {
      await this.refresh();
    }

    if (!this.selectedUser) {
      this.selectedUser = this.userEmail;
    }
  },
  mounted() {
    this.$options.timer = setTimeout(this.updateTime, 1000);
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    clearTimeout(this.$options.timer);
  },
  computed: {
    ...mapGetters("checker", {
      checks: "getCurrentChecks",
    }),
    ...mapGetters("auth", {
      isAdmin: "isAdmin",
      userEmail: "getUserEmail",
    }),
    selectableFrom() {
      return this.selectTo ? this.from : null;
    },
    lastCheck() {
      const sorter = R.sortBy(R.prop("timestamp"));
      return R.last(sorter(this.checks));
    },
    isLastCheckAnIn() {
      if (!this.lastCheck) {
        return false;
      }

      const lastCheckDate = moment(this.lastCheck.datetime);
      const today = moment();
      if (lastCheckDate.date() === today.date()) {
        return this.lastCheck.in;
      }

      return false;
    },
  },
  methods: {
    ...mapActions("checker", [
      "checkIn",
      "checkOut",
      "fetchChecks",
      "getReportUrl",
    ]),
    ...mapMutations("checker", {
      setSelected: "SET_SELECTED_CHECK",
    }),
    ...mapActions("users", ["listUsers"]),
    updateTime() {
      this.currentTimestamp = Date.now();
      this.$options.timer = setTimeout(this.updateTime, 1000);
    },
    seeCheckDetails(check) {
      this.setSelected(check);
      this.$router.push(`/checks/${check.timestamp}`);
    },
    selectedDates(ymd, date) {
      return this.from !== "" &&
        this.to !== "" &&
        this.from <= date &&
        this.to >= date
        ? "table-primary"
        : "";
    },
    handleCalendarContext(contextEvent) {
      if (!contextEvent.selectedDate) return;

      if (contextEvent.selectedDate < contextEvent.activeDate) {
        this.currentDate = contextEvent.activeDate;
        this.from = contextEvent.activeDate;
        this.to = contextEvent.activeDate;
        this.selectTo = false;
        return;
      }

      if (this.selectTo) {
        this.to = contextEvent.selectedDate;
        this.selectTo = false;
        this.refresh();
      } else {
        this.from = contextEvent.selectedDate;
        this.to = "";
        this.selectTo = true;
      }
    },
    async refresh() {
      this.loading = true;
      try {
        const filterCriteria =
          !R.isEmpty(this.to) && !R.isEmpty(this.from)
            ? {
                to: this.to.getTime(),
                from: this.from.getTime(),
              }
            : {};

        filterCriteria.email = this.selectedUser;

        await this.fetchChecks(filterCriteria);
        this.users = this.isAdmin ? await this.listUsers() : [];
      } finally {
        this.loading = false;
      }
    },
    async handleCheckIn() {
      this.loading = true;
      try {
        await this.checkIn({ email: this.selectedUser });
        await this.refresh();
      } catch (error) {
        const isConfictError = error.response && error.response.status === 409;
        const conflictErrorMessage =
          "Su última entrada no coincide con su acción pasada del día, para entrar debe de haber salido primero o empezar un día nuevo";
        const errorMessage =
          "Debes de estar conectado a la internet y que la aplicación tenga accesso a tu ubicación";

        await this.$bvModal.msgBoxOk(
          isConfictError ? conflictErrorMessage : errorMessage,
          {
            size: "sm",
            buttonSize: "sm",
            centered: true,
            footerClass: "p-2 border-top-0",
          }
        );
        this.goBack();
      } finally {
        this.loading = false;
      }
    },
    async handleCheckOut() {
      this.loading = true;
      try {
        await this.checkOut({ email: this.selectedUser });
        await this.refresh();
      } catch (error) {
        const isConfictError = error.response && error.response.status === 409;
        const conflictErrorMessage =
          "Su última entrada no coincide con su acción pasada del día, para salir debe de entrar primero";
        const errorMessage =
          "Debes de estar conectado a la internet y que la aplicación tenga accesso a tu ubicación";

        await this.$bvModal.msgBoxOk(
          isConfictError ? conflictErrorMessage : errorMessage,
          {
            size: "sm",
            buttonSize: "sm",
            centered: true,
            footerClass: "p-2 border-top-0",
          }
        );
        this.goBack();
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      this.$router.push("/");
    },
    async downloadReport() {
      this.loading = true;
      try {
        this.currentArtifactUrl = await this.getReportUrl();
        await this.$bvModal.show("download-artifact-modal");
      } catch (error) {
        await this.$bvModal.msgBoxOk(
          `Hubo un problema al generar el reporte, por favor de contactar al administrador del sistema`,
          {
            size: "sm",
            buttonSize: "sm",
            centered: true,
            footerClass: "p-2 border-top-0",
          }
        );
      } finally {
        this.loading = false;
      }
    },
  },
  filters: {
    timestamp(value) {
      return moment(value).calendar();
    },
  },
};
</script>
